const currentPageUrl = window.location.href;
const pageTitle = document.title;

document.addEventListener('DOMContentLoaded', () => {

    const sharePopup = document.querySelector(".share-component__popup");

    if (sharePopup) {
        document.querySelector('.share-component__button').addEventListener('click', () => {
            sharePopup.classList.toggle("is-active");
        })

        sharePopup.querySelector('.js-share-fb').addEventListener('click', () => {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${currentPageUrl}`, '_blank');
        });

        sharePopup.querySelector('.js-share-x').addEventListener('click', () => {
            window.open(`https://www.x.com/share?url=${currentPageUrl}`, '_blank');
        });

        sharePopup.querySelector('.js-share-linkedin').addEventListener('click', () => {
            window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${currentPageUrl}&title=${pageTitle}`, '_blank');
        });

        sharePopup.querySelector('.js-share-email').addEventListener('click', () => {
            window.open(`mailto:?subject=NewZealand Institute of Architects Incorporated - ${pageTitle}&body=${currentPageUrl}`, '_blank');
        });
    }
});
